// import { createSlice, createAsyncThunk, current } from '@reduxjs/toolkit';
// import * as filterAPI from '../../axios/Analytics';
// import { MAIN_FILTER, mergeFilterData } from '../../utils/comman';
// import { generateDefaultLobTeamAgentAsSelected } from '../../utils/redux';
// import deepmerge from 'deepmerge';
import { createSlice, createAsyncThunk, current } from '@reduxjs/toolkit';
import * as AnalyticsAPI from 'api/Analytics';
import { extraFilterSmoothMerge, smoothMerge } from 'utils/Sidebar';
import { MAIN_FILTER } from 'utils/common';
import { sortByPriorityIndex } from 'utils/redux';
import { validateErrorAndCheckArray } from 'utils/validation';

const initialState = {
  status: '',
  AnalyticsConfigData: null,
  data: null,
  features_filter: null,
  LOB: null,
  LOB2: null,
  LOBTeam: null,
  LOBTeamAgent: null,
  rangeDate: null,
  fields: {},
  selected: {
    LOB: [],
    LOBTeam: [],
    LOBTeamAgent: [],
    fields: {},
    rowFilter: {
      LOB: false,
      LOBTeam: false,
      LOBTeamAgent: false
    }
  },
  ui: {
    LOB: {
      status: '',
      loading: false,
      flag: false
    },
    LOBTeam: {
      status: '',
      loading: false,
      flag: false
    },
    LOBTeamAgent: {
      status: '',
      loading: false
    },
    loading: false
  },
  main_filter: MAIN_FILTER,
  error: null,
  none: true,
  noneTeam: true,
  noneAgent: true
};

const getFilterState = (state) => state.filter;
const getAnalyticsConfigData = createAsyncThunk('analyticsfilter/getAnalyticsConfigData', async (_, { rejectWithValue }) => {
  try {
    const res = await AnalyticsAPI.getAnalyticsConfigData();

    const data = res?.data?.data;
    if (data) {
      let extra_filter = {};
      if (data.advancefilter) {
        for (const key in data.advancefilter.features_data) {
          extra_filter[key] = {
            slug: key,
            ...data.advancefilter.features_data[key]
          };
        }
        extra_filter = sortByPriorityIndex(extra_filter);
      } else {
        extra_filter = null;
      }
      let feature_filter = {};
      if (data.addcolumn) {
        feature_filter = data?.addcolumn?.features_data;
      } else {
        feature_filter = null;
      }

      return {
        ...data,
        data: {
          extra_filter: extra_filter,
          feature_filter: feature_filter
        }
      };
    }
    return null;
  } catch (error) {
    return rejectWithValue(error);
  }
});

const filterSlice = createSlice({
  name: 'analyticsfilter',
  initialState: initialState,

  reducers: {
    resetState: () => {
      return initialState;
    },
    setDefaultLobTeamAgent: (state, action) => {
      const {
        LOB,
        LOBTeam,
        LOBTeamAgent
        // selectedLOB,
        // selectedLOBTeam,
        // selectedLOBTeamAgent,
      } = action.payload;
      state.LOB = LOB;
      state.LOBTeam = LOBTeam;
      state.LOBTeamAgent = LOBTeamAgent;
      // state.selected.LOB = selectedLOB;
      // state.selected.LOBTeam = selectedLOBTeam;
      // state.selected.LOBTeamAgent = selectedLOBTeamAgent;
    },
    setLobTeamDataByLob: (state, { payload }) => {
      state.LOBTeam = payload;
      state.LOBTeamAgent = [];
    },
    setLOBTeamAgentDataByLobTeam: (state, { payload }) => {
      state.LOBTeamAgent = payload;
    },
    changeDateRange: (state, action) => {
      state.rangeDate = action.payload;
    },
    setFieldsData: (state, action) => {
      state.fields = action.payload;
    },
    setNone: (state, action) => {
      state.none = action.payload;
    },
    setNoneTeam: (state, action) => {
      state.noneTeam = action.payload;
    },
    setNoneAgent: (state, action) => {
      state.noneAgent = action.payload;
    },
    handleLobFilterChange: (state, action) => {
      // console.error(current(state));
      console.log('actionDatas', action.payload);
      state.ui.LOB.flag = true;
      const findIndex = state.LOB.findIndex((item) => item.id === action.payload.id);
      if (!state.selected.LOB.includes(state.LOB[findIndex])) {
        state.selected.LOB[findIndex] = state.LOB[findIndex];
        state.none = false;
      }
      state.LOB.map((item) => {
        if (item) item.value = false;
      });
      state.selected.LOB.map((item) => {
        if (item) item.value = false;
      });
      if (findIndex !== -1) {
        state.selected.LOB[findIndex].value = action.payload.value;
        console.log('selected.LOB', current(state).selected.LOB);
        state.none = false;
      } else {
        state.none = true;
        state.selected.LOB.map((item) => {
          if (item) item.value = false;
        });
        state.LOB.map((item) => {
          if (item) item.value = false;
        });
      }
    },
    handleTeamFilterChange: (state, action) => {
      state.ui.LOBTeam.flag = true;
      const findIndex = state.LOBTeam.findIndex((item) => item.id === action.payload.id);
      if (!state.selected.LOBTeam.includes(state.LOBTeam[findIndex])) {
        state.selected.LOBTeam[findIndex] = state.LOBTeam[findIndex];
        state.noneTeam = false;
      }
      state.LOBTeam.map((item) => {
        if (item) item.value = false;
      });
      state.selected.LOBTeam.map((item) => {
        if (item) item.value = false;
      });
      // state.selected.LOBTeam[findIndex].value = action.payload.value;
      // state.LOBTeam[findIndex].value = action.payload.value;

      if (findIndex !== -1) {
        state.selected.LOBTeam[findIndex].value = action.payload.value;
        state.noneTeam = false;
      } else {
        state.noneTeam = true;
        state.selected.LOBTeam.map((item) => {
          if (item) item.value = false;
        });
        state.LOBTeam.map((item) => {
          if (item) item.value = false;
        });
      }
    },

    handleAgentFilterChange: (state, action) => {
      const findIndex = state.LOBTeamAgent.findIndex((item) => item.id === action.payload.id);
      state.noneAgent = false;
      state.LOBTeamAgent.map((item) => {
        if (item) item.value = false;
      });
      state.selected.LOBTeamAgent.map((item) => {
        if (item) item.value = false;
      });

      if (!state.selected.LOBTeamAgent.includes(state.LOBTeamAgent[findIndex])) {
        state.selected.LOBTeamAgent[findIndex] = state.LOBTeamAgent[findIndex];
      }
      // state.selected.LOBTeamAgent[findIndex].value = action.payload.value;
      // state.LOBTeamAgent[findIndex].value = action.payload.value;
      if (findIndex !== -1) {
        state.selected.LOBTeamAgent[findIndex].value = action.payload.value;
        state.noneAgent = false;
      } else {
        state.noneAgent = true;
        state.selected.LOBTeamAgent.map((item) => {
          if (item) item.value = false;
        });
        state.LOBTeamAgent.map((item) => {
          if (item) item.value = false;
        });
      }
    },

    handleSetExtraFilterData: (state, action) => {
      state.data.extra_filter[action.payload.filter_type].selected = action.payload.value;
    },
    setExtraFilter: (state) => {
      state.extra_filter = state.data.extra_filter;
    },
    handleRemoveExtraFilterData: (state, action) => {
      state.data.extra_filter[action.payload.filter_type].selected = null;
    },

    handleSetMultipleExtraFilterData: (state, action) => {
      if (state.data.extra_filter[action.payload.filter_type].selected instanceof Array) {
        if (state.data.extra_filter[action.payload.filter_type].selected.includes(action.payload.value)) {
          const prevData = state.data.extra_filter[action.payload.filter_type].selected;
          var index = prevData.indexOf(action.payload.value);
          if (index !== -1) {
            prevData.splice(index, 1);
          }
          // state.data.extra_filter[action.payload.filter_type].selected.pop(
          //   action.payload.value
          // );
        } else {
          state.data.extra_filter[action.payload.filter_type].selected.push(action.payload.value);
        }
      } else state.data.extra_filter[action.payload.filter_type].selected = [action.payload.value];
    },
    handleSetsingleExtraFilterData: (state, action) => {
      state.data.extra_filter[action.payload.filter_type].selected = [action.payload.value];
    },
    handleRemoveMultipleExtraFilterData: (state, action) => {
      const prevData = state.data.extra_filter[action.payload.filter_type].selected;
      var index = prevData.indexOf(action.payload.value);
      if (index !== -1) {
        prevData.splice(index, 1);
      }
      // state.data.extra_filter[action.payload.filter_type].selected.pop(
      //   action.payload.value
      // );
    },
    handleSetMultipleFeatureFilterData: (state, action) => {
      const { filter_type, index, value } = action.payload;
      state.data.feature_filter[filter_type][index].selected = value;
    },
    handleRemoveFeatureExtraFilterData: (state, action) => {
      const { filter_type, index } = action.payload;

      state.data.feature_filter[filter_type][index].selected = null;
    },
    setFeatureFilter: (state, action) => {
      state.features_filter = action.payload;
    },

    handleChangeAddtionalFields: (state, action) => {
      const { keyName, values, flag } = action.payload;

      if (!state.selected.fields.hasOwnProperty?.call(keyName)) {
        state.selected.fields[keyName] = flag;
      } else {
        state.selected.fields[keyName] = flag;
      }

      Object.keys(values)?.map((item, index) => {
        state.fields[keyName][index].selected = flag;
      });
    },
    handleChangeAddtionalSubFields: (state, action) => {
      const { parentKey, flag, index } = action.payload;
      state.fields[parentKey][index].selected = flag;
      if (!flag) state.selected.fields[parentKey] = flag;
      else {
        const original = Object.values(state.fields[parentKey]);
        const filtered = original.filter((item) => item.selected === flag);
        if (original.length === filtered.length) {
          state.selected.fields[parentKey] = flag;
        }
      }
    },
    clearLobTeamAgent: (state) => {
      const updatedLOB = state.LOB.map((item) => ({
        ...item,
        value: false
      }));
      state.LOB = updatedLOB;
      state.LOBTeam = [];
      state.LOBTeamAgent = [];
      state.selected.LOB = [];
      state.selected.LOBTeam = [];
      state.selected.LOBTeamAgent = [];
      state.none = true;
      state.noneTeam = true;
      state.noneAgent = true;
      // state.rangeDate = [];
    },

    clearExtraFilter: (state) => {
      Object.keys(state.data.extra_filter).forEach((key) => {
        state.data.extra_filter[key].selected = null;
      });
    },

    handleRemoveMultipleExtraFilterDataFromApplied: (state, action) => {
      if (validateErrorAndCheckArray(state.extra_filter[action.payload.filter_type].selected)) {
        if (validateErrorAndCheckArray(action.payload.value)) {
          state.extra_filter[action.payload.filter_type].selected = null;
        } else {
          const prevData = state.extra_filter[action.payload.filter_type].selected;
          var index = prevData.indexOf(action.payload.value);
          if (index !== -1) {
            prevData.splice(index, 1);
          }
        }
      } else {
        state.extra_filter[action.payload.filter_type].selected = null;
      }
      if (state.data.extra_filter) {
        state.data.extra_filter = state.extra_filter;
      }
    },
    setAllfilterFromParent: (state, action) => {
      // state.data = mergeFilterData(state.data, action.payload.data);
      // state.features_filter = action.payload.features_filter || state.features_filter;
      // state.LOB = action.payload.LOB;
      // state.LOB2 = action.payload.LOB2;
      // state.LOBTeam = action.payload.LOBTeam;
      // state.LOBTeamAgent = action.payload.LOBTeamAgent;
      // state.rangeDate = action.payload.rangeDate;
      // state.fields = action.payload.fields;
      // state.selected = action.payload.selected;
      if (action.payload) {
        // state.data = mergeFilterData(state.data, action.payload.data);
        // state.features_filter = action.payload.features_filter || state.features_filter;
        state.data.extra_filter = extraFilterSmoothMerge(state.data.extra_filter, action.payload.extra_filter);
        state.extra_filter = smoothMerge(state.extra_filter, action.payload.extra_filter);
        state.features_filter = smoothMerge(state.features_filter, action.payload.features_filter);
        state.LOB = action.payload.LOB;
        state.LOBTeam = action.payload.LOBTeam;
        state.LOBTeamAgent = action.payload.LOBTeamAgent;
        state.rangeDate = action.payload.rangeDate;
        state.fields = action.payload.fields;
        state.selected = action.payload.selected;
      }
    },

    setSelectedDatafromParent: (state, action) => {
      // console.log('=setSelectedDatafromParent', action.payload);
      try {
        if (action.payload.isFilterEmpty) {
          // LOB Selected
          if (state.LOB) {
            if (action.payload.Lob) {
              var findIndex = state?.LOB.findIndex((item) => item.name === action.payload.Lob);
              // console.log('Lob  index', findIndex)
              if (findIndex !== -1)
                if (!state.selected.LOB.includes(state.LOB[findIndex])) {
                  state.selected.LOB[findIndex] = state.LOB[findIndex];
                }
              state.LOB.map((item) => {
                if (item) item.value = false;
              });
              state.selected.LOB.map((item) => {
                if (item) item.value = false;
              });
              if (findIndex >= 0) state.selected.LOB[findIndex].value = true;
            }
          }
          // LOBTeam Selected
          if (state.LOBTeam) {
            if (action.payload.Team) {
              //logic to set selectedTeam when we have multiple teams in selectedRow
              // const teams = action.payload.Team.split(',')?.map((item) => item.trim());
              // if (teams.length > 1) {
              //   //check if we have parentFilters selected
              //   const selected = state.LOBTeam?.find((item) => item?.value && teams.includes(item.name));
              //   if (selected && selected.name) {
              //     action.payload.Team = selected.name;
              //   }
              // } else {
              //   action.payload.Team = teams[0];
              // }

              findIndex = state?.LOBTeam.findIndex((item) => item.name === action.payload.Team);
              if (findIndex >= 0)
                if (!state.selected.LOBTeam.includes(state.LOBTeam[findIndex])) {
                  state.selected.LOBTeam[findIndex] = state.LOBTeam[findIndex];
                }
              state.LOBTeam.map((item) => {
                if (item) item.value = false;
              });
              state.selected.LOBTeam.map((item) => {
                if (item) item.value = false;
              });
              if (findIndex >= 0) state.selected.LOBTeam[findIndex].value = true;
            }
          }
          // Agent Selected
          if (state.LOBTeamAgent) {
            if (action.payload.Agent) {
              findIndex = state.LOBTeamAgent.findIndex((item) => item.username === action.payload.Agent);
              state.LOBTeamAgent.map((item) => {
                if (item) item.value = false;
              });
              state.selected.LOBTeamAgent = state.LOBTeamAgent;
              if (findIndex >= 0)
                if (!state.selected.LOBTeamAgent.includes(state.LOBTeamAgent[findIndex])) {
                  state.selected.LOBTeamAgent[findIndex] = state.LOBTeamAgent[findIndex];
                }
              if (findIndex >= 0) state.selected.LOBTeamAgent[findIndex].value = true;
            }
          }
        }
      } catch (error) {
        console.log(error);
      }
    }
  },

  extraReducers: {
    [getAnalyticsConfigData.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },

    [getAnalyticsConfigData.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.ui.loading = false;
      const { data, ...others } = action.payload;
      state.AnalyticsConfigData = others;
      state.LOB = others?.select_lob?.value;
      state.LOBTeam = !state.LOB ? others?.select_team?.value : [];
      state.LOBTeamAgent = !state.LOB && !state.LOBTeam ? others?.select_agent?.value : [];
      state.rangeDate = others?.select_date?.value;
      state.data = data;
    },

    [getAnalyticsConfigData.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    }
  }
});

const {
  resetState,
  setFieldsData,
  changeDateRange,
  setExtraFilter,
  handleLobFilterChange,
  handleTeamFilterChange,
  handleAgentFilterChange,

  handleSetExtraFilterData,
  handleRemoveExtraFilterData,
  setFeatureFilter,
  handleSetMultipleExtraFilterData,
  handleSetsingleExtraFilterData,
  handleRemoveMultipleExtraFilterData,
  handleSetMultipleFeatureFilterData,
  handleRemoveFeatureExtraFilterData,
  handleChangeAddtionalFields,
  handleChangeAddtionalSubFields,
  clearExtraFilter,
  clearLobTeamAgent,
  setAllfilterFromParent,
  setSelectedDatafromParent,
  setDefaultLobTeamAgent,
  setLobTeamDataByLob,
  setLOBTeamAgentDataByLobTeam,
  handleRemoveMultipleExtraFilterDataFromApplied,
  setNone,
  setNoneAgent,
  setNoneTeam
} = filterSlice.actions;

export default filterSlice.reducer;

export {
  getFilterState,
  resetState,
  setFieldsData,
  setExtraFilter,
  getAnalyticsConfigData,
  changeDateRange,
  handleLobFilterChange,
  handleTeamFilterChange,
  handleAgentFilterChange,
  handleSetExtraFilterData,
  handleRemoveExtraFilterData,
  handleSetMultipleExtraFilterData,
  handleSetsingleExtraFilterData,
  handleRemoveMultipleExtraFilterData,
  handleSetMultipleFeatureFilterData,
  handleRemoveFeatureExtraFilterData,
  handleChangeAddtionalFields,
  handleChangeAddtionalSubFields,
  setFeatureFilter,
  clearExtraFilter,
  clearLobTeamAgent,
  setAllfilterFromParent,
  setSelectedDatafromParent,
  setDefaultLobTeamAgent,
  setLobTeamDataByLob,
  setLOBTeamAgentDataByLobTeam,
  handleRemoveMultipleExtraFilterDataFromApplied,
  setNone,
  setNoneAgent,
  setNoneTeam
};
